export default "__VITE_ASSET__BC2GZ6iv__"